import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center",
  style: {"margin":"8px 0 8px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "blue-grey lighten-5 primary--text" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('translationModal.title')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_form, { ref: "post_defecation_form" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "py-3" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "d-flex justify-center",
                style: {"border":"1px solid #a9a9a9","padding":"8px","border-radius":"8px"}
              }, [
                _createElementVNode("span", { style: {"font-size":"16px"} }, "English")
              ], -1)),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_icon, { style: {"font-size":"56px","text-align":"center"} }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-arrow-down-thin", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _createVNode(_component_v_select, {
                modelValue: _ctx.state,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state) = $event)),
                items: _ctx.choices,
                rules: [_ctx.rules.required],
                outlined: "",
                dense: ""
              }, null, 8, ["modelValue", "items", "rules"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.close,
                color: "error",
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('translationModal.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                onClick: _ctx.clickPost,
                loading: _ctx.btnLoading,
                color: "primary",
                disabled: _ctx.state === ''
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('translationModal.submit')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "loading", "disabled"]),
              _createVNode(_component_v_spacer)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}